/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { Component, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { ValueLabelDirective } from '../../directive/value-label.directive';

@Component({
  selector: 'kit-value-label',
  templateUrl: './value-label.component.html',
  styleUrls: ['./value-label.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ValueLabelComponent extends ValueLabelDirective { }
